import UploadVideos from './UploadVideos';

export default UploadVideos;
